import { PageNameType } from './clientConfiguration/clientConfigurationSlice';
import { RootState } from './store';

export const getBaseDomain = (pageName: PageNameType): keyof RootState =>
 pageName.split('/')[0] as keyof RootState;
